<template lang="pug">
  .b-tabs3
    button._item(v-for="tab in tabs" :key="tab.value" @click="$emit('input', tab.value)" :class="{ active: tab.value === value }" )
      span(v-if="tab.label") {{ tab.label }}
      Icon(v-if="tab.icon" :name="tab.icon" pointer)
</template>

<script>
export default {
  name: 'BaseTabs3',
  props: {
    tabs: Array,
    value: [String, Number],
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.tabs3 {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;


  &__item {
    color: #788CA1;
    font-size: 12px;
    font-weight: 500;
    padding: 7px 15px;
    background: #EBEFF2;
    border-radius: 4px;
    cursor: pointer;

    &.active {
      background: #82BCEB;
      color: #fff;
    }
  }
}
</style>
